import { render, staticRenderFns } from "./SecondaryBenchmarks.vue?vue&type=template&id=6a4728c9"
import script from "./SecondaryBenchmarks.vue?vue&type=script&lang=ts"
export * from "./SecondaryBenchmarks.vue?vue&type=script&lang=ts"
import style0 from "./SecondaryBenchmarks.vue?vue&type=style&index=0&id=6a4728c9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports